<template>
    <el-dialog
            title="选择门店"
            :visible="true"
            width="70%"
            :before-close="handleClose">
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
            <el-form-item label="门店编号:">
                <el-input v-model="form.shop_sn" clearable></el-input>
            </el-form-item>
            <el-form-item label="门店名称:">
                <el-input v-model="form.shop_name" clearable></el-input>
            </el-form-item>
            <el-form-item label="类型:">
                <el-select v-model="form.isself">
                    <el-option key="" label="全部" value=""></el-option>
                    <el-option key="1" label="直营门店" value="1"></el-option>
                    <el-option key="2" label="非直营门店" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关键词:">
                <el-input v-model="form.keywords" clearable placeholder="手机号，负责人"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="getStore()">搜索</el-button>
            </el-form-item>
        </el-form>
        <span>提示：经销商资料请在【客户】-【经销商管理】中添加、管理</span>
        <el-table
                ref="multipleTable"
                :data="tableData"
                v-loading="loading"
                height="300"
                border
                stripe
                style="margin: 20px 0"
                @selection-change="handleSelectionChange">
            <el-table-column
                    type="selection"
                    :selectable="selectable"
                    width="55">
            </el-table-column>
            <el-table-column
                    prop="shop_sn"
                    label="门店编号"
                    width="120"
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="shop_name"
                    label="门店名称"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>

            <el-table-column
                    prop="address"
                    label="门店地址"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="mobile"
                    label="手机号"
                    width="180"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="person"
                    label="负责人"
                    width="180"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="isself"
                    label="类型"
                    width="180"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    width="180"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button v-if="scope.row.flag== 1" type="text" disabled size="mini">已选择</el-button>
                    <el-button v-else  type="text" size="small" @click="choose(scope.row)">选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-button type="primary" style="margin-bottom: 10px" @click="chooseMulti()">多选</el-button>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
    </el-dialog>
</template>

<script>
    export default {
        name: "add-store",
        data() {
            return {
                postUrl:'',
                loading:false,
                form: {
                    shop_sn:'',
                    shop_name:'',
                    keywords:'',
                    isself:''
                },
                tableData: [],
                multipleSelection: [],
                //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
            }
        },
        props:{
            pushData:{
                type:Array,
                default:[]
            },
            type:{
                type:Number,
                default:0
            },
            notice_id:{
                type:String,
                default:''
            },
            source:{
                type:String,
                default:''
            }
        },
        methods:
            {
                getStore(){
                    this.loading = true;
                    this.$get(this.global + '/shops', {
                        per_page:this.pageSize,
                        page:this.pageNo,
                        shop_sn:this.form.shop_sn,
                        shop_name:this.form.shop_name,
                        isself:this.form.isself,
                        keywords:this.form.keywords
                    }).then(res => {
                        this.loading = false;
                        if(this.pushData.length == 0 ){
                            this.tableData = res.data;
                        }else{
                            this.arrayRiff(res.data,this.pushData);
                            this.tableData = res.data;
                        }
                        this.totalSize = res.meta.total;
                    }).catch(error =>{
                        this.loading = false;
                    });

                },
                //数组查询重复
                arrayRiff(a, b) {
                    for (var i = 0; i < b.length; i++) {
                        for (var j = 0; j < a.length; j++) {
                            if (a[j].id == b[i].id) {
                                a[j].flag = 1;
                            }
                        }
                    }
                    return a;
                },
                /*判别是否可以选*/
                selectable(row,index){
                    if(row.flag && row.flag == 1){
                        return false;
                    }else{
                        return true;
                    }
                },
                /*单选*/
                choose(row){
                    if(this.type == 2){
                        let snArr = [];
                        snArr.push(row.shop_sn);
                        let url =  this.postUrl+ this.notice_id + '/designee'
                        this.$patch(this.global +url, {
                            notice: this.notice_id,
                            lang:'',
                            _method:'PATCH',
                            designee_type: 2,
                            designee_sns:snArr
                        }).then(res => {
                            this.$emit('onSearch');
                            this.$emit('refresh');
                            this.$emit('handleClose');
                        }).catch(error =>{

                        });
                        return;
                    }
                    this.$emit('submit',row);
                    this.$emit('handleClose');
                },
                /*多选*/
                chooseMulti(){
                    if(this.multipleSelection.length == 0){
                        this.$message.error('请勾选数据...');
                        return;
                    }
                    if(this.type == 2){
                        let snArr = [];
                        for(var i = 0; i < this.multipleSelection.length;i++){
                            snArr.push(this.multipleSelection[i].shop_sn);
                        }
                        let url =  this.postUrl+ this.notice_id + '/designee'
                        this.$patch(this.global +url, {
                            notice: this.notice_id,
                            lang:'',
                            _method:'PATCH',
                            designee_type: 2,
                            designee_sns:snArr
                        }).then(res => {
                            this.$emit('onSearch');
                            this.$emit('refresh');
                            this.$emit('handleClose');
                        }).catch(error =>{

                        });
                        return;
                    }
                    this.$emit('submit',this.multipleSelection);
                    this.$emit('handleClose');
                },
                /*分页*/
                handleSizeChange(val) {
                    this.pageSize = val;
                    this.pageNo = 1;
                    this.getStore();
                },
                handleCurrentChange(val) {
                    this.pageNo = val;
                    this.getStore();
                },
                handleSelectionChange(val) {
                    this.multipleSelection = val;
                },
                handleClose() {
                    this.$emit('handleClose');
                }
            },
        created() {
            if(this.source == '公告'){
                this.postUrl = '/notices/';

            }else if(this.source == '文件'){
                this.postUrl = '/documents/'
            }
            this.getStore();
        },
    }
</script>

<style lang="scss" scoped>

</style>